var _rect, _rect2, _polygon, _rect3, _polygon2, _path, _line, _line2, _rect4, _line3, _line4, _rect5, _path2, _path3, _path4, _path5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDucts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b3d48619-1483-43f7-a308-8219b69f80e9",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.99,
    width: 14.36,
    height: 18.26,
    transform: "translate(48.33 18.26) rotate(-180)",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.54,
    y: 0.08,
    width: 2.73,
    height: 18.45,
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "16.99 18.26 31.35 18.26 36.88 22.93 36.88 27.18 11.45 27.18 11.45 22.93 16.99 18.26",
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.94,
    y: 22.93,
    width: 7.95,
    height: 4.25,
    transform: "translate(65.82 50.12) rotate(-180)",
    fill: "#b3b3b3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "28.93 22.93 36.88 22.93 32.51 18.52 26.52 18.52 28.93 22.93",
    fill: "#b3b3b3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.35.08V18.26h0l5.53,4.67v4.25H11.45V22.93L17,18.26h0V.08H31.35m4-4H13V16.4L8.87,19.88l-1.42,1.2v10.1H40.88V21.08l-1.42-1.2L35.35,16.4V-3.92Z",
    fill: "#1a1a1a"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 36.88,
    y1: 22.93,
    x2: 19.99,
    y2: 22.93,
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.45,
    y1: 22.93,
    x2: 14.99,
    y2: 22.93,
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.52,
    width: 4.82,
    height: 18.26,
    transform: "translate(57.87 18.26) rotate(-180)",
    fill: "#b3b3b3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 31.35,
    y1: 12.87,
    x2: 16.99,
    y2: 12.87,
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 31.35,
    y1: 7.48,
    x2: 16.99,
    y2: 7.48,
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.99,
    width: 14.36,
    height: 18.21,
    transform: "translate(48.33 18.21) rotate(-180)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.26,33.43c0,3.33-1.61,3.38-1.61,6.65,0,3.06,1.61,3.06,1.61,6.64",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.57,33.43c0,3.33-1.61,3.38-1.61,6.65,0,3.06,1.61,3.06,1.61,6.64",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.88,33.38c0,3.32-1.61,3.38-1.61,6.64,0,3.06,1.61,3.06,1.61,6.64",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.18,33.43c0,3.33-1.62,3.38-1.62,6.65,0,3.06,1.62,3.06,1.62,6.64",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.45,
    y: 23.48,
    width: 2.73,
    height: 3.7,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDucts);
export default __webpack_public_path__ + "static/media/Ducts.d879086008b557c298ed9943e4e28942.svg";
export { ForwardRef as ReactComponent };